import React from 'react';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import queryString from 'query-string';
import Browser from './Browser';

class MoatDebug extends React.Component {
  constructor(props) {
    super(props);

    const params = queryString.parseUrl(get(this.props, 'ad.url', ''));

    this.state = {
      showDebug: true,
      params: params.query,
      adId: get(params, 'query.ad_id'),
      value: 'Loading Moat...',
      showMoat: Browser.shouldShowMoatDebug(),
      viewable: 0,
      viewportSize: {
        width: 0,
        height: 0,
      },
    };
  }

  componentDidMount() {
    window.addEventListener('message', this.postMessageReceiver);
    this.waitToLogMoatParams();
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.postMessageReceiver);
  }

  postMessageReceiver = evt => {
    const stringData = typeof evt.data === 'object' ? JSON.stringify(evt.data) : evt.data;
    if (typeof stringData !== 'string' || stringData.indexOf('react-devtools') !== -1) {
      return;
    }
    let data = {};

    try {
      // 'data' is a custom object created in the postMessage sender in third_party_impr_pel.js
      // JSON.parse will throw an exception if the data is invalid json and trigger excessive logging.
      // google calls postMessage with invalid json mulitple times, so don't parse them if they do.
      if (stringData.indexOf('goog_') === -1 && typeof evt.data.googMsgType === 'undefined') {
        try {
          data = JSON.parse(stringData);
        } catch (e) {}
      } else {
        return;
      }
    } catch (e) {}

    if (data.action !== 'moat_pixel_update') {
      return;
    }
    if (!isEqual(data.moatPixel, window.server.moat)) {
      console.log('Card.postMessageReceiver - MOAT pixel updated:', data.moatPixel);

      window.server.moat = data.moatPixel;
      this.logMoatParams(this.props.ad);
    }
  };

  getMoatParams = () => {
    console.log('get moat params called!');
    const url = get(window, 'server.moat');
    return {
      moat: {
        top:
          Browser.getParameterValue('lk', url) ||
          Browser.getParameterValue('gp', url) ||
          'Not Found',
        percentViewable: Browser.getParameterValue('pg', url),
        ad: {
          w: Browser.getParameterValue('w', url),
          h: Browser.getParameterValue('h', url),
        },
      },
      e2: {
        w: this.state.viewportSize.width,
        h: this.state.viewportSize.height,
      },
    };
  };

  logMoatParams = () => {
    if (typeof window.server.moat !== 'string') {
      return;
    }
    console.log('CardView - logMoatParamsTimeout firing');

    const moatParams = this.getMoatParams();

    // This means moat has loaded and fired a pixel, because the ad width is defined
    if (get(moatParams, 'moat.ad.w')) {
      // Only check moat viewable once, since this function is called a bunch
      // The one check will get the final viewable percent
      const viewable = get(moatParams, 'moat.percentViewable');
      if (!this.state.viewable || this.state.viewable !== viewable) {
        console.log('Logging viewability of:', viewable, moatParams);

        this.setState({ viewable }, this.updateMoatValue);
      }
    }
  };

  waitToLogMoatParams = ad => {
    // An interval to check for Moat pixel quicker than a 2s fallback
    const keepChecking = setInterval(() => {
      const params = this.getMoatParams();
      if (get(params, 'moat.percentViewable', null)) {
        clearInterval(keepChecking);
        console.log('Found moat pixel, executing logging function');
        this.logMoatParams(ad);
      }
    }, 100);

    setTimeout(() => {
      clearInterval(keepChecking);
      if (this.state.showMoat) {
        const params = this.getMoatParams();
        if (!get(params, 'moat.percentViewable')) {
          const moatSeesAd = get(params, 'moat.ad.w', null);
          const value = moatSeesAd
            ? 'Found moat pixel, but viewable percent n/a'
            : 'No moat pixel found';
          this.setState({ value });
        }
      }
    }, 5000);
  };

  updateMoatValue = () => {
    if (this.state.showMoat && this.state.viewable) {
      const { m2m_relsno, impression_id } = this.props.ad;
      const moatParams = this.getMoatParams();
      window.server.log({
        fn: 'didFinishLoad',
        tag: 'IFRAME_LOG_MOAT',
        msg: 'Iframe onload MOAT parameters',
        inmarketParams: {
          componentName: 'Moat.js',
          m2m_impr_id: impression_id,
          m2m_relsno,
        },
        meta_data: moatParams,
      });

      const value = get(window, 'server.moat')
        ? `Moat viewable: ${this.state.viewable}%`
        : `No pixel fired in 2s`;

      this.setState({ value });
    }
  };

  handleChange = event => {
    this.setState({ value: event.target.value });
  };

  handleToggle = () => {
    this.setState({ showDebug: !this.state.showDebug });
  };

  render() {
    return (
      Browser.shouldShowMoatDebug() && (
        <div
          onClick={this.handleToggle}
          style={{
            opacity: 0.3,
            position: 'absolute',
            backgroundColor: 'transparent',
            zIndex: Number.MAX_SAFE_INTEGER, // Need this many to override Celtra
            color: 'white',
            top: Browser.getTopPadding(),
          }}
        >
          <textarea
            readOnly
            name="debugMsg"
            value={
              !this.state.showDebug
                ? `${this.state.viewable}%`
                : `${this.state.value}\n${JSON.stringify(this.state.params, null, 2)}`
            }
            onChange={this.handleChange}
            id="moatParamsTextArea"
            rows={this.state.showDebug ? 15 : 2}
            cols={this.state.showDebug ? 35 : 5}
          />
        </div>
      )
    );
  }
}

export default MoatDebug;
